(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lw-countdown-preview"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lw-countdown')) {
  customElements.define('lw-countdown', class extends HTMLElement {
    connectedCallback() {
      this.stop();
      this.generation = (this.generation || 0) + 1;
      const generation = this.generation;
      this.storageKey = 'laughwear:visitor-countdown:v1';
      this.onStorage = (event) => {
        if (event.key !== this.storageKey || !event.newValue) return;
        const incoming = this.parseState(event.newValue);
        if (!incoming) return;
        const current = this.state;
        if (current && this.validState(current) &&
            (current.startedAt < incoming.startedAt ||
             (current.startedAt === incoming.startedAt && current.deadline < incoming.deadline))) {
          try { localStorage.setItem(this.storageKey, JSON.stringify(current)); } catch {}
          return;
        }
        this.applyState(incoming);
      };
      this.onVisible = () => { if (!document.hidden && this.state) this.tick(); };
      this.onPageShow = () => { if (this.state) this.tick(); };
      if (this.dataset.editor === 'true') {
        this.applyState({ deadline: Date.now() + this.randomDurationSeconds() * 1000 });
        return;
      }
      const initialize = () => {
        if (!this.isConnected || generation !== this.generation) return;
        try {
          const raw = localStorage.getItem(this.storageKey);
          let state = this.parseState(raw);
          if (!state) {
            const startedAt = Date.now();
            const seconds = this.randomDurationSeconds();
            const deadline = startedAt + seconds * 1000;
            state = { version: 1, startedAt, deadline, retainUntil: deadline + 20 * 60000 };
            localStorage.setItem(this.storageKey, JSON.stringify(state));
          }
          const saved = this.parseState(localStorage.getItem(this.storageKey));
          if (!saved) throw new Error('Countdown storage unavailable');
          this.applyState(saved);
          window.addEventListener('storage', this.onStorage);
          document.addEventListener('visibilitychange', this.onVisible);
          window.addEventListener('pageshow', this.onPageShow);
        } catch {
          this.stop();
          this.hidden = true;
        }
      };
      if (navigator.locks && navigator.locks.request) {
        navigator.locks.request(this.storageKey, initialize).catch(() => {
          if (this.isConnected && generation === this.generation) initialize();
        });
      } else {
        initialize();
      }
    }
    randomDurationSeconds() {
      const minutes = 10 + Math.floor(Math.random() * 10);
      const seconds = 30 + Math.floor(Math.random() * 16);
      return minutes * 60 + seconds;
    }
    disconnectedCallback() {
      this.generation = (this.generation || 0) + 1;
      this.stop();
    }
    validState(state) {
      if (!state || state.version !== 1) return false;
      const { startedAt, deadline, retainUntil } = state;
      if (![startedAt, deadline, retainUntil].every(Number.isSafeInteger)) return false;
      const duration = deadline - startedAt;
      return duration >= 600000 && duration <= 1200000 &&
        retainUntil === deadline + 1200000 && startedAt <= Date.now() &&
        Date.now() < retainUntil;
    }
    parseState(raw) {
      try {
        const state = JSON.parse(raw);
        return this.validState(state) ? state : null;
      } catch { return null; }
    }
    applyState(state) {
      clearInterval(this.interval);
      this.state = state;
      this.deadline = state.deadline;
      this.querySelector('[data-countdown-content]').hidden = false;
      this.querySelector('[data-countdown-finished]').hidden = true;
      if (this.tick()) this.interval = setInterval(() => this.tick(), 1000);
    }
    stop() {
      clearInterval(this.interval);
      this.interval = null;
      window.removeEventListener('storage', this.onStorage);
      document.removeEventListener('visibilitychange', this.onVisible);
      window.removeEventListener('pageshow', this.onPageShow);
    }
    finish() {
      clearInterval(this.interval);
      this.interval = null;
      this.querySelector('[data-countdown-content]').hidden = true;
      const message = this.querySelector('[data-countdown-finished]');
      message.hidden = false;
      this.hidden = !message.textContent.trim();
    }
    tick() {
      const total = Math.max(0, Math.min(1200, Math.ceil((this.deadline - Date.now()) / 1000)));
      if (total === 0) { this.finish(); return false; }
      this.hidden = false;
      const values = { hours: 0, minutes: Math.floor(total / 60), seconds: total % 60 };
      for (const [key, value] of Object.entries(values)) {
        this.querySelector('[data-' + key + ']').textContent = String(value).padStart(2, '0');
      }
      return true;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lw-pocket-scarf"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lw-pocket-scarf')) {
    customElements.define('lw-pocket-scarf', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
        this.labels = JSON.parse(this.querySelector('[data-labels]').textContent);
        this.select = this.querySelector('[data-color]');
        this.select.addEventListener('change', () => this.updateVariant(this.select.value));
        this.querySelectorAll('[data-variant]').forEach(button => button.addEventListener('click', () => { this.select.value = button.dataset.variant; this.updateVariant(button.dataset.variant); }));
        const selected = new URL(window.location.href).searchParams.get('variant');
        if (selected && this.variants.some(v => String(v.id) === selected)) { this.select.value = selected; this.updateVariant(selected); }
      }
      updateVariant(id) {
        const variant = this.variants.find(v => String(v.id) === String(id));
        if (!variant) return;
        this.querySelector('[data-price]').textContent = variant.price;
        const compare = this.querySelector('[data-compare]');
        compare.textContent = variant.compare;
        compare.hidden = !variant.onSale;
        const image = this.querySelector('.lw-scarf__main-image');
        if (variant.image) { image.removeAttribute('srcset'); image.src = variant.image; image.alt = variant.alt; }
        const add = this.querySelector('[data-add]');
        add.disabled = !variant.available;
        add.textContent = variant.available ? this.labels.add : this.labels.unavailable;
        this.querySelectorAll('[data-variant]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.variant === String(id))));
        const url = new URL(window.location.href);
        url.searchParams.set('variant', id);
        window.history.replaceState({}, '', url);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lw-product-preview"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('lw-product'))customElements.define('lw-product',class extends HTMLElement{
    connectedCallback(){
      if(this.ready)return;this.ready=true;
      this.variants=JSON.parse(this.querySelector('[data-variants]').textContent);
      this.labels=JSON.parse(this.querySelector('[data-labels]').textContent);
      this.select=this.querySelector('select[name=id]');this.thumbs=[...this.querySelectorAll('.lw-thumb')];
      this.addEventListener('click',e=>{const thumb=e.target.closest('.lw-thumb'),step=e.target.closest('[data-gallery-step]');if(thumb)this.setImage(thumb.dataset.image,thumb.dataset.alt,true);if(step)this.step(Number(step.dataset.galleryStep));if(e.target.closest('.lw-photo')&&!this.swiped){const image=this.querySelector('.lw-hero'),zoom=this.querySelector('.lw-zoom-image');zoom.removeAttribute('srcset');zoom.src=image.src;zoom.alt=image.alt;this.querySelector('dialog').showModal();}if(e.target.closest('.lw-zoom-close')||e.target===this.querySelector('dialog'))this.querySelector('dialog').close();this.swiped=false;if(e.target.closest('kaching-bundle')){clearTimeout(this.syncTimer);this.syncTimer=setTimeout(()=>this.syncFromForm(),120);}});
      this.addEventListener('change',e=>{if(this.syncing)return;if(e.target.matches('.lw-option input'))this.updateVariant();else if(e.target===this.select)this.syncFromForm();else if(e.target.closest('kaching-bundle')){clearTimeout(this.syncTimer);this.syncTimer=setTimeout(()=>this.syncFromForm(),100);}});
      this.querySelector('.lw-gallery').addEventListener('keydown',e=>{if(e.target.closest('dialog'))return;if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();this.step(e.key==='ArrowRight'?1:-1);}});
      const photo=this.querySelector('.lw-photo');photo.addEventListener('touchstart',e=>{this.touchX=e.changedTouches[0].clientX;this.touchY=e.changedTouches[0].clientY;},{passive:true});photo.addEventListener('touchend',e=>{const dx=e.changedTouches[0].clientX-this.touchX,dy=e.changedTouches[0].clientY-this.touchY;if(Math.abs(dx)>50&&Math.abs(dx)>Math.abs(dy)){this.swiped=true;this.step(dx<0?1:-1);}},{passive:true});
      const chart=this.querySelector('.lw-chart-dialog'),chartTrigger=this.querySelector('.lw-size-chart-trigger');
      chartTrigger.addEventListener('click',()=>chart.showModal());
      chart.addEventListener('click',e=>{if(e.target===chart)chart.close();});
      const motionVideo=this.querySelector('.lw-motion-video');
      if(motionVideo){motionVideo.muted=true;motionVideo.defaultMuted=true;motionVideo.controls=false;const reducedMotion=matchMedia('(prefers-reduced-motion: reduce)');const updateMotion=()=>{if(reducedMotion.matches){motionVideo.pause();motionVideo.removeAttribute('autoplay');}else{motionVideo.autoplay=true;motionVideo.play().catch(()=>{});}};updateMotion();this.motionPreference=reducedMotion;this.motionChange=updateMotion;reducedMotion.addEventListener('change',updateMotion);}
      this.classList.add('is-ready');this.syncFromForm(false);
    }
    disconnectedCallback(){clearTimeout(this.syncTimer);if(this.motionPreference)this.motionPreference.removeEventListener('change',this.motionChange);}
    step(direction){const current=Math.max(0,this.thumbs.findIndex(t=>t.getAttribute('aria-pressed')==='true'));const thumb=this.thumbs[(current+direction+this.thumbs.length)%this.thumbs.length];if(thumb)this.setImage(thumb.dataset.image,thumb.dataset.alt,true);}
    setImage(src,alt,scroll=false){const image=this.querySelector('.lw-hero');if(!image||!src)return;image.removeAttribute('srcset');image.src=src;if(alt)image.alt=alt;const path=new URL(src,location.href).pathname;this.thumbs.forEach((thumb,index)=>{const active=new URL(thumb.dataset.image,location.href).pathname===path;thumb.setAttribute('aria-pressed',String(active));if(active){this.querySelector('[data-photo-count]').textContent=`${index+1} / ${this.thumbs.length}`;if(scroll){const rail=thumb.parentElement;rail.scrollTo({left:thumb.offsetLeft-rail.offsetLeft,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});}}});}
    syncFromForm(changeUrl=true){const variant=this.variants.find(v=>String(v.id)===this.select.value);if(!variant)return;this.querySelectorAll('.lw-option').forEach((field,index)=>field.querySelectorAll('input').forEach(input=>{input.checked=input.value===variant.options[index];}));this.renderVariant(variant,changeUrl);}
    updateVariant(){const values=[...this.querySelectorAll('.lw-option')].map(f=>f.querySelector('input:checked')?.value);const variant=this.variants.find(v=>v.options.every((value,index)=>value===values[index]));this.select.value=variant?String(variant.id):'';this.renderVariant(variant,true);this.syncing=true;this.select.dispatchEvent(new Event('change',{bubbles:true}));this.syncing=false;}
    renderVariant(variant,changeUrl){const button=this.querySelector('.lw-add');button.disabled=!variant||!variant.available;button.textContent=!variant?this.labels.unavailable:variant.available?this.labels.add:this.labels.sold;if(!variant)return;if(this.lastPrice!==variant.price){this.querySelector('[data-price]').textContent=variant.price;this.lastPrice=variant.price;}const compare=this.querySelector('[data-compare]');compare.hidden=!variant.compare;if(this.lastCompare!==variant.compare){compare.textContent=variant.compare||'';this.lastCompare=variant.compare;}if(this.activeVariant!==variant.id&&variant.image)this.setImage(variant.image,undefined,true);this.activeVariant=variant.id;if(changeUrl){const url=new URL(location.href);url.searchParams.set('variant',variant.id);history.replaceState({},'',url);}const values=variant.options;this.querySelectorAll('.lw-option').forEach((field,index)=>field.querySelectorAll('input').forEach(input=>{input.disabled=!this.variants.some(v=>v.available&&v.options.every((value,i)=>value===(i===index?input.value:values[i])));}));}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
